import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';

import { GasColor } from '../../../core/colors/color.namespace';
import { MONTH } from '../gas-datepicker.interface';

@Component({
  selector: 'gas-month',
  templateUrl: './gas-month.component.html',
  styleUrls: ['../gas-datepicker.component.scss', './gas-month.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GasMonthComponent {
  @Input()
  public currentMonth: number = null;

  @Output()
  public onChangeMonth: EventEmitter<number> = new EventEmitter();

  public gasColor = GasColor.Color;
  public months: string[] = MONTH;

  /** эмитим наверх выбранный пользователем месяц */
  public changeMonth(monthIndex: number): void {
    this.onChangeMonth.emit(monthIndex);
  }

  /** эмитим наверх текущий месяц (нажатие на кнопку назад) */
  public backToDatepicker(): void {
    this.onChangeMonth.emit(this.currentMonth);
  }
}
